import { fetchAllChallans } from '../../../services/outwardChallans'

export const ActionTypes = {
  FETCH_ALL_CHALLANS: 'FETCH_ALL_CHALLANS',
}

export const fetchAllChallansAction = (isGst: boolean | null, challanType: string, finYear: string | null, partyId?: string) => ({
  type: ActionTypes.FETCH_ALL_CHALLANS,
  promise: fetchAllChallans(isGst, challanType, finYear, partyId),
})

export const fetchAllChallansResetAction = () => ({
  type: `${ActionTypes.FETCH_ALL_CHALLANS}_RESET`,
})
